import React from 'react'
import { Outlet } from 'react-router'

const BlankLayout = () => {
  return (
    <div>
      <div className="layout">
        <main id="pageContent">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export default BlankLayout
